import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Accordion, Card } from 'react-bootstrap';

// Layout
import Header1 from '../layout/header/header2';
import Footer1 from '../layout/footer/footer1';

// Elements
import SolutionSidebar from '../elements/services/solution-sidebar';

// Images
import Banner1 from '../../images/banner/banner1.jpg';
import ServicesPic1 from '../../images/services/service_4.jpeg';
import ServicesPic2 from '../../images/services/pic2.jpg';

class SolutionRealTimeMonitoring extends Component {

	render() {
		return (
			<>
				<Header1 />

				<div className="page-content bg-white">

					<div className="page-banner ovbl-dark parallax" style={{ backgroundImage: "url(" + Banner1 + ")" }}>
						<div className="container">
							<div className="page-banner-entry">
								<h1 className="text-white">Real-Time Monitoring & Surveillance</h1>
								<div className="breadcrumb-row">
									<ul className="list-inline">
										<li><Link to="/"><i className="fa fa-home"></i> Home</Link></li>
										<li>Real-Time Monitoring</li>
									</ul>
								</div>
							</div>
						</div>
					</div>

					<div className="content-block" id="content-area">
						<div className="section-area section-sp2 bg-white">
							<div className="container about-video">
								<div className="row">

									<div className="col-lg-4 col-md-5 m-b30">
										 <SolutionSidebar activeService={4} />
									</div>

									<div className="col-lg-8 col-md-7 service-textarea">
										<div className="heading-bx text-left m-b20">
											<h3 className="title-head m-b0">Real-Time Monitoring & Surveillance</h3>
											<div className="ttr-separator sepimg"></div>
										</div>

										<p>
											We provide advanced real-time monitoring systems ensuring continuous 
											surveillance of well performance, equipment integrity, and production 
											operations through automated sensing and digital analytics.
										</p>

										<div className="row m-b30">
											<div className="col-md-12">
												<img src={ServicesPic1} className="radius-sm imghight" alt="" />
											</div>
										</div>

										<h4 className="title m-b5">Our Solutions</h4>
										<p>
											Our monitoring solutions help operators anticipate failures, optimize 
											production, and maintain safe and reliable operations.
										</p>

										<div className="row">
											<div className="col-lg-6">
												<ul className="list-check">
													<li>Automated surveillance systems</li>
													<li>Digital well performance dashboards</li>
													<li>Remote real-time alerts</li>
												</ul>
											</div>
											<div className="col-lg-6">
												<ul className="list-check">
													<li>Predictive failure analysis</li>
													<li>IoT-based sensing networks</li>
												</ul>
											</div>
										</div>

										<h4 className="title m-b5">Benefits</h4>
										<p>Advanced monitoring delivers accurate, real-time data to improve operational decisions.</p>

										<div className="row">
											<div className="col-xl-7 col-lg-12">
												<ul className="service-list-circle">
													<li><i className="flaticon-maintenance"></i>Improved operational visibility</li>
													<li><i className="flaticon-light-bolt"></i>Reduced downtime risks</li>
													<li><i className="flaticon-mask"></i>Enhanced safety and reliability</li>
												</ul>
											</div>
										</div>

										<Accordion className="ttr-accordion gray" defaultActiveKey="0">
											<Card>
												<Accordion.Toggle as={Card.Header} eventKey="0">
													<Link to="#">Digital Sensors</Link>
												</Accordion.Toggle>
												<Accordion.Collapse eventKey="0">
													<Card.Body>
														High-resolution multisource digital sensors ensuring real-time measurements.
													</Card.Body>
												</Accordion.Collapse>
											</Card>
											<Card>
												<Accordion.Toggle as={Card.Header} eventKey="1">
													<Link to="#">Data Processing</Link>
												</Accordion.Toggle>
												<Accordion.Collapse eventKey="1">
													<Card.Body>
														Advanced analytics enabling remote predictive decision-making.
													</Card.Body>
												</Accordion.Collapse>
											</Card>
										</Accordion>

									</div>
								</div>
							</div>
						</div>

					</div>

				</div>

				<Footer1 />

			</>
		);
	}
}

export default SolutionRealTimeMonitoring;
